(function() {
    'use strict';
   
    angular.module('quantixApp')
        .controller('PortfolioNewsController',PortfolioNewsController);
    

    PortfolioNewsController.$inject = ['$scope','$state',  'PortfolioService','GenericService','ErrorHandlerService','NEWS'];
     
     function PortfolioNewsController($scope, $state,PortfolioService,GenericService,ErrorHandlerService,NEWS) {
    	 
    	 
    	GenericService.getUserModuleAccessData().then(function(result){
			$scope.userModuleAccessData = result;
		});
		 var sectionaccess={};
		 GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess=result;
			if(sectionaccess["Portfolio View.Portfolio - News"] != 'Y') {
				ErrorHandlerService.forbiddenError(NEWS);
				return;
				}
		});
 		
        $scope.portfolioId = $state.params.portfolioId;
        $scope.selectedPortName = $state.params.selectedPortName;
        $scope.portfolioDateTime = $state.params.portfolioDateTime;
        
        
        $scope.getSelectedPortfolioNewsData = function(){
        	var portfolioVONews = {
					'id' : $scope.portfolioId,
					'pageNumber' : 1,
					'pageSize' : 1,
					'newsId': $state.params.id
				}
        	PortfolioService.getPortfolioNewsData(portfolioVONews).then(
					function(data) {
						$scope.newsData = data;
					}, function(error) {
						
					});
        }
	
		$scope.gotolandingpage = function(){
    		 $state.go('portfolioDashboard', {
					'portfolioId' : $scope.portfolioId,
					'portfolioName' : ''
				});
    	 }
		
		$scope.getSelectedPortfolioNewsData();
		
		
		$scope.getBackToPortfolioDetails=function(){
			$state.go('portfolioLanding', {
				'portfolioId' : $scope.portfolioId,
				'portfolioName' : $scope.selectedPortName,
				'portfolioType' : $scope.portfolioType,
				'portfolioDateTime' : $scope.portfolioDateTime
			});
		}
	
     }
 
})();


